// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloudDownloadOutlinedSvg from "@fishx/icons-svg/es/asn/PCloudDownloadOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloudDownloadOutlined = function PCloudDownloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloudDownloadOutlinedSvg
  }));
};

PCloudDownloadOutlined.displayName = 'PCloudDownloadOutlined';
export default React.forwardRef(PCloudDownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloudDownloadOutlined.js
// module id = 3294
// module chunks = 0